import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * In Tailwind zet `text-lg` óók een regelhoogte, en daarom gooit tailwind-merge
 * standaard elke eerdere `leading-*` weg zodra er later een lettergrootte langskomt.
 *
 * In dit design system klopt die aanname niet: alle maten zijn arbitrair
 * (`text-[30px]`) en elke regelhoogte wordt expliciet gezet, meestal vóór de maat.
 * Het gevolg was zichtbaar — de KPI-cijfers op het dashboard kregen regelhoogte
 * 1.55 in plaats van 1.1 — en het trof ook `MonoLabel`, `Button` en mono-tabelcellen.
 *
 * We heffen dat ene conflict daarom op. Wie een regelhoogte wil, zet hem; wie hem
 * niet zet, krijgt de waarde uit het token. Alle andere conflictregels blijven staan.
 */
const twMerge = extendTailwindMerge({
    override: {
        conflictingClassGroups: {
            'font-size': [],
        },
    },
});

/**
 * Voegt klassenamen samen en lost conflicterende Tailwind-utilities op.
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
